var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"commercial-products-form"},[_c('commercial-form',{attrs:{"loading":_vm.loading,"sections":_vm.sections},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }